export const environment = {
  //uri: 'https://localhost:7213/',
  uri: 'https://testappxeno.azurewebsites.net/',
  production: true
};
 